import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import decryptJWT from '../../../utils/decryptJWT';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';

export default function SelectFatCicloDeVida(props) {
    const [spinAtivo, setSpinAtivo] = useState(false);
    const [lsCicloDeVida, setLsCicloDeVida] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleStatus(codigoStatus, NomeStatus){
        props.setCdStatus(codigoStatus)
        props.setDsStatus(NomeStatus)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectFatCicloDeVida(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderStatus(){
            const {data} = await api_gateway.get('/m1/consultar/fat_ciclo_vida?cd_pav_usuario='+decryptJWT('codigo')+'&selecionar='+true)
            

            if(data.dados.length > 0){
                let objetoCicloDeVida = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.CD_CICLO_VIDA}>
                            <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleStatus(item.CD_CICLO_VIDA, item.DS_STATUS) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.DS_STATUS}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsCicloDeVida(objetoCicloDeVida)
            }else{
                let objetoCicloDeVida = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsCicloDeVida(objetoCicloDeVida)
            }
            setSpinAtivo(false)
        }
        renderStatus()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectFatCicloDeVida(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsStatus}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsCicloDeVida}
                </ul>
            </div>
        </Form>
    )
}